export default __webpack_public_path__ + "assets/grand-salon-moderne-quebec.15742faa.webp";